// SharingRatioValue — shared inline rendering of a sharing ratio.
//
// Renders `{numerator} : 1` where the numerator inherits the surrounding
// font size and the denominator (" : 1") is smaller and muted (T.light).
//
// Props:
//   numerator  {string}  — already-formatted ratio string, e.g. "0.94"
//   fontSize   {string}  — fontSize token for the "1" denominator span;
//                          defaults to T.fsLg (matches the Overview card treatment)

import React from "react";
import { T } from "../app/tokens.js";

export function SharingRatioValue({ numerator, fontSize = "0.55em" }) {
  return (
    <>
      {numerator} :{" "}
      <span style={{ fontSize, fontWeight: T.fwSemibold, color: T.light }}>1</span>
    </>
  );
}
